export const getLogoSrc = (logo) => {
  if (!logo) return null;
  if (logo.startsWith('data:')) return logo;
  if (/^https?:\/\//i.test(logo)) return logo;
  return `${process.env.REACT_APP_SPACES_BASE}/logos/${logo}`;
};

export default getLogoSrc;
